const state = {
  nota_data: [],
};
export default state;
